<p [class]="'text-' + align">
    <span name="ottimizza-text" #paragraph>
        <ng-content></ng-content>
    </span>
    <a (click)="expand()" *ngIf="reduced" class="ottimizza-text-expand-trigger text-info cursor-pointer ml-2">Ver mais</a>
</p>
